import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';
import _ from 'lodash';
import { Typography } from '@design-system/components/typography/typography';
import { useElementObserver } from '@client/new/hooks/useElementObserver';
import { IconButton } from '@design-system/components/button/iconButton';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export const TemplateSelection = ({
  templates,
  control,
  disabled,
  observedId,
  dispatch,
}: {
  templates: EditWorkoutVM['templateSelection'];
  control: EditWorkoutVM['control'];
  disabled?: boolean;
  observedId: string;
  dispatch: EditWorkoutVM['dispatch'];
}) => {
  const { isVisibleInViewport } = useElementObserver({ observedId });

  if (_.isEmpty(templates)) return null;

  const errorMessage = control.getFieldState('exercises').error?.message;

  return (
    <div
      className={clsx(
        isVisibleInViewport && 'flex',
        !isVisibleInViewport && 'sticky top-4 shadow-gallery',
      )}
      style={{ zIndex: 2 }}
    >
      <div
        className={clsx(
          'flex justify-center items-center bg-white p-4 gap-4 md:gap-0 rounded-xl flex-wrap w-full relative',
          errorMessage &&
            sprinkles({
              borderColor: 'ERROR-100',
              borderWidth: 's',
            }),
          disabled && 'pointer-events-none',
        )}
      >
        {templates.map(({ label, className, icon, onClick }) => (
          <div
            key={label}
            className="flex w-max-content bg-[#F8F8F8] gap-[11px] p-2 mx-4 rounded-md cursor-pointer hover:shadow-gallery"
            onClick={onClick}
          >
            <div
              className={clsx(
                className,
                'flex justify-center items-center w-[26px] h-[26px] rounded-md',
              )}
            >
              <FontAwesomeIcon icon={icon} />
            </div>
            <Typography
              variant="body"
              size="large"
              className="leading-[18px] flex items-center"
            >
              {label}
            </Typography>
          </div>
        ))}
        {errorMessage && (
          <span
            className={clsx(
              'text-[12px] basis-full text-center pt-2',
              sprinkles({ color: 'ERROR-100', fontFamily: 'visuelt' }),
            )}
          >
            {errorMessage}
          </span>
        )}
        <IconButton
          className="absolute right-5"
          icon={faInfoCircle}
          color="neutral"
          variant="text"
          onClick={() => dispatch('openExerciseTypeInfo')}
        />
      </div>
    </div>
  );
};
